(function ($){
    let store_locator = $('.store-locator__map');

    store_locator.each(function (){
        let map_container = $(this);

        initMap(map_container[0]);
    });

    function initMap(map_container) {

        let locations = STORE_ARRAY,
            icon = THEME_URL + '/build/img/svg/marker.svg',
            map = new google.maps.Map(map_container, {
            center: new google.maps.LatLng(20.59, 78.96),
            mapTypeId: 'roadmap',
            mapTypeControl: false,
            streetViewControl: false,
            panControl: false,
            zoom: 8,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_BOTTOM
            },
        });

        let infowindow = new google.maps.InfoWindow({
            maxWidth: 235
        });

        let markers = [];

        // Add the markers and infowindows to the map
        for (let i = 0; i < locations.length; i++) {
            let lat = locations[i].latitude,
                long = locations[i].longitude;
            let marker = new google.maps.Marker({
                position: new google.maps.LatLng(lat, long),
                map: map,
                icon: icon,
                title: 'Click to zoom'
            });

            markers.push(marker);

            $('.store-locator__show-on-map').on('click', function (e){
                e.preventDefault();
                google.maps.event.trigger(markers[$(this).attr('href')],'click');
            });

            google.maps.event.addListener(marker, 'click', (function(marker, i) {

                return function() {
                    let description = locations[i].description.length > 1 ? '<p>' + locations[i].description +'</p>' : '';
                    let title = locations[i].title.length > 1 ? '<h3>' + locations[i].title + '</h3>' : '';
                    let address = locations[i].title.length > 1 ? '<p>' + locations[i].address + '</p>' : '';
                    infowindow.setContent('<div class="map-marker">' + title + address + description + '</div>');
                    infowindow.open(map, marker);
                    map.setZoom(8);
                    map.setCenter(marker.getPosition());
                }
            })(marker, i));
        }

        function autoCenter() {
            //  Create a new viewpoint bound
            let bounds = new google.maps.LatLngBounds();
            //  Go through each...
            for (let i = 0; i < markers.length; i++) {
                bounds.extend(markers[i].position);
            }
            //  Fit these bounds to the map
            map.fitBounds(bounds);
        }
        autoCenter();

        setTimeout(function (){
            $('.store-locator__show-on-map').first().trigger('click');
        }, 500);
    }

    $('#location-choose').on('change', function() {
        setGetParameter('country_code', this.value)
        location.reload()
    });

}(jQuery));


function setGetParameter(paramName, paramValue)
{
    let url = window.location.href;
    if (url.indexOf(paramName + "=") >= 0)
    {
        var prefix = url.substring(0, url.indexOf(paramName));
        var suffix = url.substring(url.indexOf(paramName));
        suffix = suffix.substring(suffix.indexOf("=") + 1);
        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
        url = prefix + paramName + "=" + paramValue + suffix;
    }
    else
    {
        if (url.indexOf("?") < 0)
            url += "?" + paramName + "=" + paramValue;
        else
            url += "&" + paramName + "=" + paramValue;
    }
    window.history.pushState({ path: url }, '', url)
}